import {
  Component, OnInit, Input, ViewChild
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { DocumentVersionInput, Object as Objekt } from 'graphql/models/generated';
import { BaseComponent } from 'shared/base/base.component';
import { CoreDataService } from 'shared/services/core-data.service';
import { StoreService } from 'shared/services/store.service';

import { ObjektBasicInfoComponent } from '../basic-info/basic-info.component';

@Component({
  selector: 'app-objekt-basic-info-modal',
  templateUrl: './basic-info-modal.component.html',
  styleUrls: ['./basic-info-modal.component.scss']
})
export class ObjektBasicInfoModalComponent extends BaseComponent implements OnInit {
  @ViewChild(ObjektBasicInfoComponent) basicInfoComponent!: ObjektBasicInfoComponent;

  @Input() item!: Objekt;

  docVersion!: DocumentVersionInput;

  get form(): UntypedFormGroup {
    return this.basicInfoComponent.form;
  }

  constructor(
    protected coreDataService: CoreDataService,
    protected storeService: StoreService
  ) {
    super();
  }

  ngOnInit(): void {
    this.storeService.getCurrentOffer()
      .pipe(filter((o) => Boolean(o && o.documentId)), takeUntil(this.destroyed$))
      .subscribe((o) => {
        this.docVersion = { documentId: o.documentId, revision: o.revision };
      });
  }

  onSubmit(): Observable<Objekt> {
    return this.coreDataService.createObject(this.form.value, this.docVersion);
  }
}
